// useState は関数を含むオブジェクトを共有できないため provide/inject で共有する
import { QueryClient } from "@tanstack/vue-query";

export const useTanQueryClientKey = "useTanQueryClientKey";
export const createTanQueryClient = () => new QueryClient({
  defaultOptions: { queries: { staleTime: 30000 } },
});

export const registerTanQueryClient = () => provide(useTanQueryClientKey, createTanQueryClient());
export const useTanQueryClient = () => inject<QueryClient>(useTanQueryClientKey)!;
